// ******************************************************
// ******************************************************
// ******************************************************
// *****    Definition of the VectorFonts.
// *****    This code is generated. Do not edit manaully.
// ******************************************************
// ******************************************************
// ******************************************************
import { tbVectorFont } from "../../engine/tbVectorFont";
import { tbVectorFontLoader } from "../../engine/tbVectorFontLoader";
export var angrybirds_regular;
export var angrybirds_regularLoader;
export var angrybirds_regular_text;
export var angrybirds_regular_textLoader;
export var SF_Slapstick_Comic;
export var SF_Slapstick_ComicLoader;
export var initializeFonts = function () {
    angrybirds_regularLoader = new tbVectorFontLoader("angrybirds_regular", "fonts/angrybirds_regular.woff", "fonts/angrybirds_regular.ttf", "fonts");
    angrybirds_regular = new tbVectorFont("angrybirds_regular", "Arial");
    angrybirds_regular.setFontSize(12);
    angrybirds_regular.setAlign("left");
    angrybirds_regular.setBaseline("top");
    angrybirds_regular.setOffsetFactor(0 / 100);
    angrybirds_regular.setLineSpacing(0);
    angrybirds_regular.setFill(true);
    angrybirds_regular.setFillColor("Black");
    angrybirds_regular.setFillAlpha(100 / 100);
    angrybirds_regular.setStroke(false);
    angrybirds_regular.setStrokeColor("Black");
    angrybirds_regular.setStrokeWidth(1);
    angrybirds_regular.setStrokeJoin("miter");
    angrybirds_regular.setStrokeAlpha(100 / 100);
    angrybirds_regular.setStrokeBehind(false);
    angrybirds_regular_textLoader = new tbVectorFontLoader("angrybirds_regular_text", "fonts/angrybirds_regular_text.woff", "fonts/angrybirds_regular_text.ttf", "fonts");
    angrybirds_regular_text = new tbVectorFont("angrybirds_regular_text", "Arial");
    angrybirds_regular_text.setFontSize(12);
    angrybirds_regular_text.setAlign("left");
    angrybirds_regular_text.setBaseline("top");
    angrybirds_regular_text.setOffsetFactor(0 / 100);
    angrybirds_regular_text.setLineSpacing(0);
    angrybirds_regular_text.setFill(true);
    angrybirds_regular_text.setFillColor("Black");
    angrybirds_regular_text.setFillAlpha(100 / 100);
    angrybirds_regular_text.setStroke(false);
    angrybirds_regular_text.setStrokeColor("Black");
    angrybirds_regular_text.setStrokeWidth(1);
    angrybirds_regular_text.setStrokeJoin("miter");
    angrybirds_regular_text.setStrokeAlpha(100 / 100);
    angrybirds_regular_text.setStrokeBehind(false);
    SF_Slapstick_ComicLoader = new tbVectorFontLoader("SF_Slapstick_Comic", "fonts/SF_Slapstick_Comic.woff", "fonts/SF_Slapstick_Comic.ttf", "fonts");
    SF_Slapstick_Comic = new tbVectorFont("SF_Slapstick_Comic", "Arial");
    SF_Slapstick_Comic.setFontSize(25);
    SF_Slapstick_Comic.setAlign("left");
    SF_Slapstick_Comic.setBaseline("top");
    SF_Slapstick_Comic.setOffsetFactor(0 / 100);
    SF_Slapstick_Comic.setLineSpacing(0);
    SF_Slapstick_Comic.setFill(true);
    SF_Slapstick_Comic.setFillColor("White");
    SF_Slapstick_Comic.setFillAlpha(100 / 100);
    SF_Slapstick_Comic.setStroke(true);
    SF_Slapstick_Comic.setStrokeColor("Black");
    SF_Slapstick_Comic.setStrokeWidth(3);
    SF_Slapstick_Comic.setStrokeJoin("bevel");
    SF_Slapstick_Comic.setStrokeAlpha(100 / 100);
    SF_Slapstick_Comic.setStrokeBehind(true);
};
